import { ResponsiveLine } from '@nivo/line';
import React, { useEffect, useRef, useState } from 'react'
import { VeltNivoChartComments } from '@veltdev/react';

const dataset1 = [
    {
        "id": "japan",
        "color": "hsl(124, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 84
            },
            {
                "x": "helicopter",
                "y": 249
            },
            {
                "x": "boat",
                "y": 113
            },
            {
                "x": "train",
                "y": 63
            },
            {
                "x": "subway",
                "y": 12
            },
            {
                "x": "bus",
                "y": 128
            },
            {
                "x": "car",
                "y": 155
            },
            {
                "x": "moto",
                "y": 20
            },
            {
                "x": "bicycle",
                "y": 295
            },
            {
                "x": "horse",
                "y": 219
            },
            {
                "x": "skateboard",
                "y": 126
            },
            {
                "x": "others",
                "y": 6
            }
        ]
    },
    {
        "id": "france",
        "color": "hsl(232, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 121
            },
            {
                "x": "helicopter",
                "y": 149
            },
            {
                "x": "boat",
                "y": 103
            },
            {
                "x": "train",
                "y": 179
            },
            {
                "x": "subway",
                "y": 157
            },
            {
                "x": "bus",
                "y": 194
            },
            {
                "x": "car",
                "y": 17
            },
            {
                "x": "moto",
                "y": 220
            },
            {
                "x": "bicycle",
                "y": 267
            },
            {
                "x": "horse",
                "y": 150
            },
            {
                "x": "skateboard",
                "y": 268
            },
            {
                "x": "others",
                "y": 196
            }
        ]
    },
    {
        "id": "us",
        "color": "hsl(186, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 36
            },
            {
                "x": "helicopter",
                "y": 81
            },
            {
                "x": "boat",
                "y": 249
            },
            {
                "x": "train",
                "y": 112
            },
            {
                "x": "subway",
                "y": 251
            },
            {
                "x": "bus",
                "y": 191
            },
            {
                "x": "car",
                "y": 170
            },
            {
                "x": "moto",
                "y": 128
            },
            {
                "x": "bicycle",
                "y": 284
            },
            {
                "x": "horse",
                "y": 16
            },
            {
                "x": "skateboard",
                "y": 75
            },
            {
                "x": "others",
                "y": 56
            }
        ]
    },
    {
        "id": "germany",
        "color": "hsl(359, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 127
            },
            {
                "x": "helicopter",
                "y": 119
            },
            {
                "x": "boat",
                "y": 36
            },
            {
                "x": "train",
                "y": 149
            },
            {
                "x": "subway",
                "y": 201
            },
            {
                "x": "bus",
                "y": 53
            },
            {
                "x": "car",
                "y": 276
            },
            {
                "x": "moto",
                "y": 55
            },
            {
                "x": "bicycle",
                "y": 108
            },
            {
                "x": "horse",
                "y": 43
            },
            {
                "x": "skateboard",
                "y": 208
            },
            {
                "x": "others",
                "y": 214
            }
        ]
    },
    {
        "id": "norway",
        "color": "hsl(173, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 131
            },
            {
                "x": "helicopter",
                "y": 46
            },
            {
                "x": "boat",
                "y": 298
            },
            {
                "x": "train",
                "y": 23
            },
            {
                "x": "subway",
                "y": 36
            },
            {
                "x": "bus",
                "y": 251
            },
            {
                "x": "car",
                "y": 86
            },
            {
                "x": "moto",
                "y": 294
            },
            {
                "x": "bicycle",
                "y": 197
            },
            {
                "x": "horse",
                "y": 80
            },
            {
                "x": "skateboard",
                "y": 102
            },
            {
                "x": "others",
                "y": 70
            }
        ]
    }
];

const dataset2 = [
    {
        "id": "japan",
        "color": "hsl(124, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 185
            },
            {
                "x": "helicopter",
                "y": 185
            },
            {
                "x": "boat",
                "y": 296
            },
            {
                "x": "train",
                "y": 17
            },
            {
                "x": "subway",
                "y": 120
            },
            {
                "x": "bus",
                "y": 211
            },
            {
                "x": "car",
                "y": 174
            },
            {
                "x": "moto",
                "y": 213
            },
            {
                "x": "bicycle",
                "y": 31
            },
            {
                "x": "horse",
                "y": 190
            },
            {
                "x": "skateboard",
                "y": 263
            },
            {
                "x": "others",
                "y": 81
            }
        ]
    },
    {
        "id": "france",
        "color": "hsl(232, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 276
            },
            {
                "x": "helicopter",
                "y": 76
            },
            {
                "x": "boat",
                "y": 76
            },
            {
                "x": "train",
                "y": 74
            },
            {
                "x": "subway",
                "y": 236
            },
            {
                "x": "bus",
                "y": 227
            },
            {
                "x": "car",
                "y": 166
            },
            {
                "x": "moto",
                "y": 190
            },
            {
                "x": "bicycle",
                "y": 154
            },
            {
                "x": "horse",
                "y": 137
            },
            {
                "x": "skateboard",
                "y": 117
            },
            {
                "x": "others",
                "y": 187
            }
        ]
    },
    {
        "id": "us",
        "color": "hsl(186, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 31
            },
            {
                "x": "helicopter",
                "y": 85
            },
            {
                "x": "boat",
                "y": 114
            },
            {
                "x": "train",
                "y": 209
            },
            {
                "x": "subway",
                "y": 208
            },
            {
                "x": "bus",
                "y": 74
            },
            {
                "x": "car",
                "y": 16
            },
            {
                "x": "moto",
                "y": 138
            },
            {
                "x": "bicycle",
                "y": 191
            },
            {
                "x": "horse",
                "y": 246
            },
            {
                "x": "skateboard",
                "y": 118
            },
            {
                "x": "others",
                "y": 8
            }
        ]
    },
    {
        "id": "germany",
        "color": "hsl(359, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 194
            },
            {
                "x": "helicopter",
                "y": 218
            },
            {
                "x": "boat",
                "y": 94
            },
            {
                "x": "train",
                "y": 60
            },
            {
                "x": "subway",
                "y": 140
            },
            {
                "x": "bus",
                "y": 225
            },
            {
                "x": "car",
                "y": 33
            },
            {
                "x": "moto",
                "y": 194
            },
            {
                "x": "bicycle",
                "y": 73
            },
            {
                "x": "horse",
                "y": 103
            },
            {
                "x": "skateboard",
                "y": 130
            },
            {
                "x": "others",
                "y": 149
            }
        ]
    },
    {
        "id": "norway",
        "color": "hsl(173, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 19
            },
            {
                "x": "helicopter",
                "y": 118
            },
            {
                "x": "boat",
                "y": 95
            },
            {
                "x": "train",
                "y": 245
            },
            {
                "x": "subway",
                "y": 160
            },
            {
                "x": "bus",
                "y": 137
            },
            {
                "x": "car",
                "y": 55
            },
            {
                "x": "moto",
                "y": 59
            },
            {
                "x": "bicycle",
                "y": 74
            },
            {
                "x": "horse",
                "y": 151
            },
            {
                "x": "skateboard",
                "y": 144
            },
            {
                "x": "others",
                "y": 47
            }
        ]
    }
];

const dataset3 = [
    {
        "id": "japan",
        "color": "hsl(124, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 117
            },
            {
                "x": "helicopter",
                "y": 226
            },
            {
                "x": "boat",
                "y": 290
            },
            {
                "x": "train",
                "y": 68
            },
            {
                "x": "subway",
                "y": 203
            },
            {
                "x": "bus",
                "y": 130
            },
            {
                "x": "car",
                "y": 22
            },
            {
                "x": "moto",
                "y": 83
            },
            {
                "x": "bicycle",
                "y": 262
            },
            {
                "x": "horse",
                "y": 180
            },
            {
                "x": "skateboard",
                "y": 27
            },
            {
                "x": "others",
                "y": 158
            }
        ]
    },
    {
        "id": "france",
        "color": "hsl(232, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 256
            },
            {
                "x": "helicopter",
                "y": 256
            },
            {
                "x": "boat",
                "y": 270
            },
            {
                "x": "train",
                "y": 166
            },
            {
                "x": "subway",
                "y": 29
            },
            {
                "x": "bus",
                "y": 21
            },
            {
                "x": "car",
                "y": 93
            },
            {
                "x": "moto",
                "y": 55
            },
            {
                "x": "bicycle",
                "y": 65
            },
            {
                "x": "horse",
                "y": 209
            },
            {
                "x": "skateboard",
                "y": 133
            },
            {
                "x": "others",
                "y": 224
            }
        ]
    },
    {
        "id": "us",
        "color": "hsl(186, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 93
            },
            {
                "x": "helicopter",
                "y": 192
            },
            {
                "x": "boat",
                "y": 88
            },
            {
                "x": "train",
                "y": 193
            },
            {
                "x": "subway",
                "y": 84
            },
            {
                "x": "bus",
                "y": 22
            },
            {
                "x": "car",
                "y": 256
            },
            {
                "x": "moto",
                "y": 192
            },
            {
                "x": "bicycle",
                "y": 229
            },
            {
                "x": "horse",
                "y": 294
            },
            {
                "x": "skateboard",
                "y": 297
            },
            {
                "x": "others",
                "y": 136
            }
        ]
    },
    {
        "id": "germany",
        "color": "hsl(359, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 118
            },
            {
                "x": "helicopter",
                "y": 121
            },
            {
                "x": "boat",
                "y": 160
            },
            {
                "x": "train",
                "y": 225
            },
            {
                "x": "subway",
                "y": 253
            },
            {
                "x": "bus",
                "y": 69
            },
            {
                "x": "car",
                "y": 77
            },
            {
                "x": "moto",
                "y": 239
            },
            {
                "x": "bicycle",
                "y": 256
            },
            {
                "x": "horse",
                "y": 153
            },
            {
                "x": "skateboard",
                "y": 176
            },
            {
                "x": "others",
                "y": 189
            }
        ]
    },
    {
        "id": "norway",
        "color": "hsl(173, 70%, 50%)",
        "data": [
            {
                "x": "plane",
                "y": 79
            },
            {
                "x": "helicopter",
                "y": 39
            },
            {
                "x": "boat",
                "y": 67
            },
            {
                "x": "train",
                "y": 273
            },
            {
                "x": "subway",
                "y": 138
            },
            {
                "x": "bus",
                "y": 95
            },
            {
                "x": "car",
                "y": 236
            },
            {
                "x": "moto",
                "y": 66
            },
            {
                "x": "bicycle",
                "y": 121
            },
            {
                "x": "horse",
                "y": 44
            },
            {
                "x": "skateboard",
                "y": 61
            },
            {
                "x": "others",
                "y": 217
            }
        ]
    }
];

const datasets = {
    'dataset1': {
        id: 'dataset1',
        label: 'Dataset 1',
        data: JSON.parse(JSON.stringify(dataset1))
    },
    'dataset2': {
        id: 'dataset2',
        label: 'Dataset 2',
        data: JSON.parse(JSON.stringify(dataset2))
    },
    'dataset3': {
        id: 'dataset3',
        label: 'Dataset 3',
        data: JSON.parse(JSON.stringify(dataset3))
    },
}

function NivoLineChartExample() {


    const [selectedDataset, setSelectedDataset] = useState(datasets.dataset1);

    const MyTooltip = ({ point }: any) => (
        <div
            style={{
                background: 'white',
                padding: '9px 12px',
                border: '1px solid #ccc',
            }}
        >
            <strong>{point.id}</strong>
            <br />
            Value: {point.data.yFormatted}
        </div>
    );

    const MySliceTooltip = ({ slice }: any) => (
        <div
            style={{
                background: 'white',
                padding: '9px 12px',
                border: '1px solid #ccc',
            }}
        >
            <div>My slice tooltip</div>

        </div>
    );

    function randomizeData(data: any) {
        return data.map((countryData: any) => ({
            ...countryData,
            data: countryData.data.map((point: any) => ({
                ...point,
                y: Math.floor(Math.random() * 300) // Assuming you want 'y' values between 0 and 300
            }))
        }));
    }

    const onRandomizeData = () => {
        setSelectedDataset(randomizeData(selectedDataset));
    }

    return (
        <div>
            <h3>Line chart</h3>
            <div className='nivo-charts-tabs'>
                {
                    Object.values(datasets).map((dataset) => (
                        <div
                            key={dataset.id}
                            className={`nivo-charts-tab ${dataset?.id === selectedDataset?.id ? 'active' : ''}`}
                            onClick={() => setSelectedDataset(dataset)}
                        >
                            {dataset.label}
                        </div>
                    ))
                }
            </div>
            <div style={{ height: 400, width: '100%' }} className='nivo-chart-container'>
                <ResponsiveLine
                    data={selectedDataset.data}
                    layers={[
                        'grid',
                        'markers',
                        'axes',
                        'areas',
                        'crosshair',
                        'lines',
                        'slices',
                        'legends',
                        'points',
                        (chartComputedData: any) => {
                            return (
                                <VeltNivoChartComments id="NivoLineChartExample" chartComputedData={chartComputedData} />
                            )
                        }
                    ]}
                    curve='linear'
                    enableGridX={true}
                    enableGridY={true}
                    enablePoints={true}
                    enablePointLabel={true}
                    pointLabel={(d) => d.y.toString()}
                    colors={{ scheme: 'nivo' }}
                    enableArea={true}
                    areaOpacity={0.35}
                    areaBlendMode='multiply'
                    areaBaselineValue={0}
                    lineWidth={2}
                    isInteractive={true}
                    debugMesh={false}
                    tooltip={MyTooltip}
                    enableSlices='x'
                    // enableSlices={false}
                    debugSlices={false}
                    sliceTooltip={MySliceTooltip}
                    enableCrosshair={true}
                    crosshairType='bottom-right'
                    role='img'
                    defs={[]}
                    fill={[]}

                    margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
                    xScale={{ type: 'point' }}
                    yScale={{
                        type: 'linear',
                        min: 'auto',
                        max: 'auto',
                        stacked: true,
                        reverse: false
                    }}
                    yFormat=" >-.2f"
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'transportation',
                        legendOffset: 36,
                        legendPosition: 'middle',
                        truncateTickAt: 0
                    }}
                    axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'count',
                        legendOffset: -40,
                        legendPosition: 'middle',
                        truncateTickAt: 0
                    }}
                    pointSize={10}
                    pointColor={{ theme: 'background' }}
                    pointBorderWidth={2}
                    pointBorderColor={{ from: 'serieColor' }}
                    pointLabelYOffset={-12}
                    enableTouchCrosshair={true}
                    useMesh={true}
                    legends={[
                        {
                            anchor: 'bottom-right',
                            direction: 'column',
                            justify: false,
                            translateX: 100,
                            translateY: 0,
                            itemsSpacing: 0,
                            itemDirection: 'left-to-right',
                            itemWidth: 80,
                            itemHeight: 20,
                            itemOpacity: 0.75,
                            symbolSize: 12,
                            symbolShape: 'circle',
                            symbolBorderColor: 'rgba(0, 0, 0, .5)',
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemBackground: 'rgba(0, 0, 0, .03)',
                                        itemOpacity: 1
                                    }
                                }
                            ]
                        }
                    ]}
                />
            </div>
        </div>
    )
}

export default NivoLineChartExample;